
import { Mixins, Component } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import loading from "@/mixins/loading";
import { getMixDetectionRecordList } from "@/api/fourDiagnose"
import dayjs from "dayjs";

const curDomain = `${window.location.origin}`;

@Component({ name: 'mixDetection-index',
  components: { ETable }
})
export default class mixDetection extends Mixins(loading, tablePagination) {
  EditDialogVisible: boolean = false;
  dialogTitle = "";

  statusOptions = [
    {
      label: "启用",
      value: 1
    },
    {
      label: "禁用",
      value: 0
    }
  ]

  queryForm = {
    times: [],
    storeName: "",
    storeShowName: "",
    userName: "",
    phone: ""
  };
  itemTotal = 0;
  tableData = [];

  libCodeEnum = {
    "10010": "运动体测",
    "10011": "膳养体测",
  }

  columns = [
    { label: "ID", prop: "id" },
    { label: "数据来源", prop: "sourceDesc", minWidth: "140px" },
    { label: "门店外显名称", prop: "storeShowName", minWidth: "140px" },
    { label: "检测类型", prop: "", formatter: (row) => { return this.libCodeEnum[row.libCode] } },
    { label: "检测时间", prop: "detectionEndTime" },
    { label: "检测结果", prop: "", formatter: (row) => { return "健康指数：" + row.detectionResult }, minWidth: "120px" },
    { label: "用户名称", prop: "userName" },
    { label: "手机号", prop: "phone", width: "120px" },
    { label: "设备编号", prop: "deviceCode" },
    { label: "操作", prop: "action", width: "120px" }
  ]
  mounted() {
    this.getData();
  }

  searchData() {
    this.resetCurrent();
    this.getData();
  }

  getData() {
    const { times } = this.queryForm;
    const params = {
      ...this.queryForm,
      pageNum: this.currentPage,
      pageSize: this.pageSize,
      startTime: (times || [])[0] && dayjs((times || [])[0]).format("YYYY-MM-DD HH:mm:ss"),
      endTime: (times || [])[1] && dayjs((times || [])[1]).format("YYYY-MM-DD HH:mm:ss"),
    }
    this.showLoading();
    getMixDetectionRecordList(params).then((res) => {
      this.tableData = res.data.list;
      this.itemTotal = res.data.total;
    })
  }

  goUserList(row) {
    this.$router.push({
      path: "/userMember",
      query: { phone: row.phone }
    })
  }

  open(row) {
    const url = this.getReportUrl(row);
    window.open(url);
  }

  getReportUrl(row) {
    return `${curDomain}/h5/#/mixDetection/result?qrCodeUid=${row.code}&libCode=${row.libCode}`;
  }
}

